export const ResourceModeConst = {
  NONE: '',
  VIEW: '+r',
  CREATE: '+cr',
  EDIT: '+crud',
  ADMIN: '+cruda',
};
